import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReconstructionControl = _resolveComponent("ReconstructionControl")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reconstructions, (_, key) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_component_ReconstructionControl, {
          value: _ctx.reconstructions[key],
          onInput: ($event: any) => (_ctx.reconstructions[key] = $event),
          validate: _ctx.validate,
          key: key,
          "type-options": _ctx.typeOptions,
          "extent-options": _ctx.extentOptions,
          onRemove: ($event: any) => (_ctx.removeReconstruction(key))
        }, null, 8, ["value", "onInput", "validate", "type-options", "extent-options", "onRemove"]))
      ]))
    }), 256)),
    _createElementVNode("button", {
      class: "btn btn-outline-primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addReconstruction()))
    }, _toDisplayString(_ctx.$t('form.reconstructions.buttonAddReconstruction')), 1)
  ]))
}